import { createFileRoute } from "@tanstack/react-router";
import { PINE_RIDGE_STANDING_SEAM_STUDY as study } from "@/components/site/case-studies";
import { ProjectStudyPage, projectStudyHead } from "@/components/site/CaseStudy";

export const Route = createFileRoute("/projects/standing-seam-metal-roof-pine-ridge-fl")({
  head: () => projectStudyHead(study),
  component: Page,
});

function Page() {
  return <ProjectStudyPage study={study} />;
}
